import {
  FaSchool, FaChartLine, FaLaptopCode, FaHeartbeat,
  FaUsersCog, FaCloud, FaHotel, FaChurch,
} from 'react-icons/fa';

export const serviceHashAliases = {
  'school-management-system': 'school-management', 'business-analytics-system': 'business-analytics',
  'web-mobile-app-development': 'web-mobile-apps', 'healthcare-management-systems': 'healthcare',
  'enterprise-solutions': 'enterprise', 'cloud-hosting-devops': 'cloud-devops',
  'hotel-management-system': 'hotel-management', 'church-leadership-ministry-tools': 'church-tools',
};
export const getServiceSlug = (title = '') => title.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
export const getServiceHashId = service => serviceHashAliases[getServiceSlug(service.title)] || getServiceSlug(service.title) || service.id;
export const getServiceIcon = title => ({
  'school-management-system': <FaSchool />, 'business-analytics-system': <FaChartLine />, 'web-mobile-app-development': <FaLaptopCode />,
  'healthcare-management-systems': <FaHeartbeat />, 'enterprise-solutions': <FaUsersCog />, 'cloud-hosting-devops': <FaCloud />,
  'hotel-management-system': <FaHotel />, 'church-leadership-ministry-tools': <FaChurch />,
}[getServiceSlug(title)] || null);
